export default [
  'mdiCart',
  'mdiCartOutline',
  'mdiCartVariant',
  'mdiCellphone',
  'mdiVolumeHigh',
  'mdiVolumeLow',
  'mdiVolumeMinus',
  'mdiVolumePlus',
  'mdiVolumeOff',
  'mdiSignal',
  'mdiCamera',
  'mdiHome',
  'mdiHomeOutline',
  'mdiCogOutline',
  'mdiCog',
  'mdiCogOff',
  'mdiCogOffOutline',
  'mdiApps',
  'mdiAppsBox',
  'mdiGauge',
  'mdiRobot',
  'mdiAccount',
  'mdiAccountMultiple',
  'mdiAccountBoxMultiple',
  'mdiAccountBox',
  'mdiAccountBoxMultipleOutline',
  'mdiAccountBoxOutline',
  'mdiBadgeAccountHorizontal',
  'mdiBadgeAccountHorizontalOutline',
  'mdiImageFilterDrama',
  'mdiCloud',
  'mdiCloudDownload',
  'mdiCloudCheck',
  'mdiCloudAlert',
  'mdiCloudSync',
  'mdiCloudSearch',
  'mdiCloudOutline',
  'mdiCloudDownloadOutline',
  'mdiCloudCheckOutline',
  'mdiCloudSyncOutline',
  'mdiCloudSearchOutline',
  'mdiCloudUploadOutline',
  'mdiUpload',
  'mdiClockOutline',
  'mdiClock',
  'mdiHistory',
  'mdiCached',
  'mdiLockOpen',
  'mdiLock',
  'mdiLockOpenOutline',
  'mdiLockOutline',
  'mdiWifi',
  'mdiCurrencyUsd',
  'mdiCurrencyCny',
  'mdiGenderFemale',
  'mdiGenderMale',
  'mdiGift',
  'mdiGiftOpen',
  'mdiGiftOutline',
  'mdiGiftOpenOutline',
  'mdiPackageVariantClosed',
  'mdiPackageVariant',
  'mdiGoogleDownasaur',
  'mdiApple',
  'mdiCompass',
  'mdiCompassOutline',
  'mdiMapMarker',
  'mdiMapMarkerOutline',
  'mdiMessage',
  'mdiMessageOutline',
  'mdiQrcode',
  'mdiQrcodeScan',
  'mdiPrinter',
  'mdiViewDashboard',
  'mdiViewDashboardOutline',
  'mdiStorefront',
  'mdiStorefrontOutline',
  'mdiTag',
  'mdiTagOutline',
  'mdiTagMultiple',
  'mdiTagMultipleOutline',
  'mdiThumbUp',
  'mdiThumbDown',
  'mdiThumbUpOutline',
  'mdiThumbDownOutline',
  'mdiConnection',
  'mdiSourceBranch',
  'mdiExport',
  'mdiReload',
  'mdiCalendarBlank',
  'mdiCalendarBlankOutline',
  'mdiShareVariant',
  'mdiShareVariantOutline',
  'mdiImageSizeSelectActual',
  'mdiResizeBottomRight',
  'mdiConsole',
  'mdiFolderOpenOutline',
  'mdiParachuteOutline',
  'mdiFaceManProfile',
];
